const reports = [
  {
    name: "Додаткова фінансова звітність",
    file: "Додаткова фінансова звітність.pdf",
  },
  {
    name: "Баланс",
    file: "Баланс.pdf",
  },
  {
    name: "Звіт про рух коштів",
    file: "Звіт про рух коштів.pdf",
  },
  {
    name: "Звіт про фінансові результати",
    file: "Звіт про фінансові результати.pdf",
  },
  {
    name: "Звіт аудитора про фінансову звітність",
    file: "Звіт_аудитора_про_фінансову_звітність.pdf",
  },
  {
    name: "Стратегія ЮКСА щодо соціально екологічної стійкості",
    file: "Стратегія_ЮКСА_щодо_соціально_екологічної_стійкості.pdf",
  },
];

export default reports;
